import React from "react";
import { Link } from "react-router-dom";
import { IndianRupee, Battery, Gauge, Shield, TrendingUp, Percent } from "lucide-react";
import { SEO } from "@/components/common/SEO";

const tools = [
  { to: "/tools/emi", title: "EMI Calculator", desc: "Compute EMIs and total interest for any car loan.", icon: IndianRupee, testId: "tool-link-emi" },
  { to: "/tools/ownership", title: "Ownership Cost", desc: "True per-km cost across fuel, insurance and depreciation.", icon: Gauge, testId: "tool-link-ownership" },
  { to: "/tools/ev-readiness", title: "EV Readiness", desc: "Score your lifestyle for going electric today.", icon: Battery, testId: "tool-link-ev" },
  { to: "/tools/insurance", title: "Insurance Cost", desc: "Estimate comprehensive premiums with add-ons.", icon: Shield, testId: "tool-link-insurance" },
  { to: "/tools/fuel-vs-ev", title: "Fuel vs EV Savings", desc: "Long-term savings and breakeven year.", icon: TrendingUp, testId: "tool-link-fuel-ev" },
  { to: "/tools/dealer-discount", title: "Dealer Discount Predictor", desc: "AI-estimated discounts by car, city and month.", icon: Percent, testId: "tool-link-discount" },
];

export default function Tools() {
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12" data-testid="tools-page">
      <SEO title="Car Tools & Calculators" description="EMI, insurance, ownership cost, EV readiness and dealer discount tools for Indian buyers."/>
      <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Tools</div>
      <h1 className="font-display text-4xl sm:text-5xl mt-2 tracking-tighter">Numbers, decoded.</h1>
      <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {tools.map((t) => (
          <Link key={t.title} to={t.to} data-testid={t.testId} className="group rounded-3xl border border-border bg-card/30 p-6 hover:border-foreground/30 hover:-translate-y-1 transition-all">
            <div className="w-12 h-12 rounded-2xl bg-gradient-ai text-white grid place-items-center mb-5"><t.icon className="w-5 h-5"/></div>
            <div className="font-display text-xl tracking-tight">{t.title}</div>
            <div className="text-sm text-muted-foreground mt-2">{t.desc}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
